<template>
  <div class="jobs">
    <Hero
      title=""
      :image="'banner-vaga.jpg'"
      height="75vh"
      textAlign="left"
      :search="false"
    />
    <div class="row pb-5">
      <div class="col-12 col-lg-10 mx-auto">
        <Jobs />
      </div>
    </div>
  </div>
</template>

<script>
import Jobs from "@/components/jobs/Jobs.vue";
import SearchJob from "@/components/jobs/SearchJob.vue";
import Hero from "@/components/media/Hero.vue";
export default {
  name: "JobsList",

  head() {
    return this.$head({
      title: "Vagas | ",
    });
  },

  components: {
    Jobs,
    SearchJob,
    Hero,
  },
};
</script>

<style lang="scss">
.jobs {
  .searchJob {
    .input-group {
      .form-control,
      .btn {
        height: calc(3.5rem + 2px);
        display: flex;
      }
    }
  }
}
</style>